import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DateTime } from "luxon";

import Localization from "../../../../localization";
import IconArrow from "../../../../components/icons/arrow";

import { loadSlotsAvailable } from "../../../../redux/actions/spaces";
import { getMe } from "../../../../redux/selectors/me";

class Step2Form extends Component {
    constructor(props) {
        super(props);

        let now = DateTime.local();

        this.state = {
            selected: (this.props.values && this.props.values.slots) || [],
            visibleWeek: now.weekNumber,
            visibleYear: now.year,
        };

        this._onChange = this._onChange.bind(this);

        this.myRef = React.createRef();

        this._prevWeek = this._prevWeek.bind(this);
        this._nextWeek = this._nextWeek.bind(this);
        this._loadSlots = this._loadSlots.bind(this);
    }

    componentDidMount() {
        const { studio, locale } = this.props;

        this.studioId = 6;
        if (studio === Localization[locale].spaces_booking.step_1_studio_1)
            this.studioId = 1;
        else if (studio === Localization[locale].spaces_booking.step_1_studio_2)
            this.studioId = 2;
        else if (studio === Localization[locale].spaces_booking.step_1_studio_3)
            this.studioId = 3;
        else if (studio === Localization[locale].spaces_booking.step_1_studio_4)
            this.studioId = 4;

        this.props.myRef(this.myRef);

        this._loadSlots();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.visibleWeek !== prevState.visibleWeek ||
            this.state.visibleYear !== prevState.visibleYear
        ) {
            this._loadSlots();
        }
    }

    _prevWeek() {
        const { visibleWeek, visibleYear } = this.state;

        let day = DateTime.local().set({
            weekNumber: visibleWeek,
            weekYear: visibleYear,
            weekday: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        day = day.minus({ week: 1 });

        this.setState({
            visibleWeek: day.weekNumber,
            visibleYear: day.weekYear,
        });
    }

    _nextWeek() {
        const { visibleWeek, visibleYear } = this.state;

        let day = DateTime.local().set({
            weekNumber: visibleWeek,
            weekYear: visibleYear,
            weekday: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        day = day.plus({ week: 1 });

        this.setState({
            visibleWeek: day.weekNumber,
            visibleYear: day.weekYear,
        });
    }

    _loadSlots() {
        const { visibleWeek, visibleYear } = this.state;

        let begin = DateTime.now()
            .set({
                weekNumber: visibleWeek,
                weekYear: visibleYear,
            })
            .startOf("week");
        let end = DateTime.now()
            .set({
                weekNumber: visibleWeek,
                weekYear: visibleYear,
            })
            .endOf("week");

        this.props.loadSlotsAvailable(this.studioId, begin, end);
    }

    _onChange(selected) {
        this.myRef.current.setFieldValue("slots", selected);

        this.setState({
            selected,
        });
    }

    _renderHour(hour) {
        const { slots } = this.props;
        const { selected } = this.state;

        let className =
            "transition-colors rounded-full border border-blue py-8";

        let daySlots = slots[hour.toISODate()];

        let status = "not_available";
        if (daySlots && daySlots.includes(hour.hour)) {
            if (selected.includes(hour.toISODate() + "T" + hour.hour)) {
                status = "selected";
            } else {
                status = "available";
            }
        }

        if (status === "not_available") {
            className += " opacity-20 cursor-default";
        } else if (status === "selected") {
            className += " text-white bg-blue";
        }

        return (
            <button
                disabled={status === "not_available"}
                key={hour.hour}
                className={className}
                type="button"
                onClick={() => {
                    let selected = this.state.selected.slice();

                    let index = selected.indexOf(
                        hour.toISODate() + "T" + hour.hour
                    );
                    if (index > -1) {
                        selected.splice(index, 1);
                    } else {
                        selected.push(hour.toISODate() + "T" + hour.hour);
                    }
                    this._onChange(selected);
                }}
            >
                <p className="text-14 font-judge font-bold">
                    {hour.toFormat("H") +
                        "h" +
                        " - " +
                        hour.plus({ hour: 1 }).toFormat("H") +
                        "h"}
                </p>
            </button>
        );
    }

    _renderDay(day) {
        let short =
            day.weekdayShort.charAt(0).toUpperCase() +
            day.weekdayShort.slice(1);
        if (!short.includes(".")) {
            short += ".";
        }

        let hours = [];
        for (let i = 0; i < 24; i++) {
            hours.push(day.set({ hour: i, minute: 0 }));
        }

        return (
            <div
                key={day.weekday}
                className="border-r last:border-r-0 border-blue text-center px-10 first:pl-0 last:pr-0 h-full"
            >
                <p className="text-15 text-blue pb-8">
                    {short}
                    <span className="text-20 pl-2 font-judge font-bold">
                        {day.day}
                    </span>
                </p>
                <div className="grid grid-cols-1 gap-4 overflow-y-auto">
                    {hours.map((hour) => this._renderHour(hour))}
                </div>
            </div>
        );
    }

    _renderWeek() {
        const { visibleWeek, visibleYear, selected } = this.state;
        const { user } = this.props;

        let firstDay = DateTime.local().set({
            weekNumber: visibleWeek,
            weekYear: visibleYear,
            weekday: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        let lastDay = DateTime.local().set({
            weekNumber: visibleWeek,
            weekYear: visibleYear,
            weekday: 7,
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 59,
        });

        let text = "";
        if (firstDay.month !== lastDay.month) {
            text =
                firstDay.day +
                " " +
                firstDay.monthShort +
                " - " +
                lastDay.day +
                " " +
                lastDay.monthShort;
        } else {
            text =
                firstDay.day + " - " + lastDay.day + " " + firstDay.monthShort;
        }

        let textClassName = "flex-1 text-right font-judge text-30 font-bold";
        if (selected.length < 4 || selected.length > user.available_quota) {
            textClassName += " text-red";
        }

        return (
            <div className="flex items-center -ml-15 mb-20">
                <button type="button" className="p-15" onClick={this._prevWeek}>
                    <IconArrow className="w-25 h-25 transform -rotate-90" />
                </button>
                <p className="font-judge text-30 font-bold uppercase p-15 w-208 text-center">
                    {text}
                </p>
                <button type="button" className="p-15" onClick={this._nextWeek}>
                    <IconArrow className="w-25 h-25 transform rotate-90" />
                </button>
                <div className={textClassName}>{selected.length + "h"}</div>
            </div>
        );
    }

    _validate = (values) => {
        const { locale, user } = this.props;

        const errors = {};

        if (
            values.slots.length < 4 &&
            user.role !== "admin" &&
            user.role !== "super_admin"
        ) {
            errors.slots = Localization[locale].validation.min_slots;
        } else if (
            values.slots > user.available_quota &&
            user.role !== "admin" &&
            user.role !== "super_admin"
        ) {
            errors.slots = Localization[locale].validation.required;
        } else {
            let count = 0;
            let valid = true;
            values.slots
                .sort((a, b) => {
                    let dateA = a.split("T");
                    let dateB = b.split("T");
                    let dayA = dateA[0];
                    let dayB = dateB[0];
                    let hourA = dateA[1];
                    let hourB = dateB[1];

                    if (dayA === dayB) {
                        return hourA - hourB;
                    } else if (dateA > dateB) {
                        return 1;
                    } else {
                        return -1;
                    }
                })
                .forEach((slot) => {
                    let array = slot.split("T");
                    let day = array[0];
                    let hour = array[1];
                    let dateString =
                        day + "T" + hour.padStart(2, "0") + ":00:00";

                    let date = DateTime.fromISO(dateString).plus({ hours: 1 });
                    let nextSlot = date
                        .toFormat("yyyy-LL-dd H")
                        .split(" ")
                        .join("T");

                    if (values.slots.includes(nextSlot)) {
                        count++;
                    } else if (count < 3) {
                        valid = false;
                    } else {
                        count = 0;
                    }
                });
            if (
                !valid &&
                user.role !== "admin" &&
                user.role !== "super_admin"
            ) {
                errors.slots = Localization[locale].validation.booking_slots;
            }
        }

        return errors;
    };

    render() {
        const { visibleWeek, visibleYear } = this.state;
        const { user } = this.props;

        const initialValues = {
            slots: [],
        };

        let days = [];
        for (let i = 1; i <= 7; i++) {
            let date = DateTime.local().set({
                weekNumber: visibleWeek,
                weekYear: visibleYear,
                weekday: i,
            });
            days.push(date);
        }

        return (
            <Formik
                initialValues={initialValues}
                validate={this._validate}
                //validationSchema={registSchema}
                innerRef={this.myRef}
                onSubmit={(values) => {}}
            >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-26">
                            <p className="font-bold text-20 xl:text-30 text-blue">
                                Min: 4h / Max: {user.available_quota}h
                            </p>
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="slots" />
                            </p>
                        </div>
                        {this._renderWeek()}
                        <div className="overflow-x-auto hide-scroll">
                            <div className="grid grid-cols-7 h-full min-w-600">
                                {days.map((day) => this._renderDay(day))}
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
    slots: state.spaces.slots,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadSlotsAvailable,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Step2Form);
